module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9ade0dfd35c5ffeb56956798cc3c6f36.png";